/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function PasswordValidationController(
    this: JS5Object,
    _: JS5Object,
    $scope: JS5Object,
) {
    this.requirements = [{
        getDescription: () => `Minimum Length: ${this.passwordRequirements.minLength}`,
        isValid: () => (this.password.length >= _.get(this, 'passwordRequirements.minLength')),
    }, {
        getDescription: () => `Minimum Uppercase Letters: ${this.passwordRequirements.numUppers}`,
        isValid: () => (this.password.replace(/[^A-Z]/g, '').length >= _.get(this, 'passwordRequirements.numUppers')),
    }, {
        getDescription: () => `Minimum Lowercase Letters: ${this.passwordRequirements.numLowers}`,
        isValid: () => (this.password.replace(/[^a-z]/g, '').length >= _.get(this, 'passwordRequirements.numLowers')),
    }, {
        getDescription: () => `Minimum Numerics: ${this.passwordRequirements.numNumerics}`,
        isValid: () => (this.password.replace(/[^0-9]/g, '').length >= _.get(this, 'passwordRequirements.numNumerics')),
    }, {
        getDescription: () => `Minimum Special Characters: ${this.passwordRequirements.numSpecials}`,
        isValid: () => (this.password.replace(/[^!@#$%^&*()?:;~|]/g, '').length >= _.get(this, 'passwordRequirements.numSpecials')),
    }];

    $scope.$watch(() => {
        return _.get(this, 'editorForm.$valid', false);
    }, () => {
        this.isValid = _.get(this, 'editorForm.$valid', false);
    });
}


angular.module('prism-ui.users').component('passwordValidation', {
    templateUrl: 'system/users/editor/passwordValidation/password-validation-template.html',
    controller: PasswordValidationController,
    bindings: {
        password: '<',
        passwordRequirements: '<',
        isValid: '=',
    }
});
